<template>
    <layout-internal-container>
        <div class="flex flex-col md:flex-row justify-between w-full items-start md:items-end gap-4">
            <div class="flex flex-col gap-2">
                <span class="text-sm text-light font-medium">
                    Here's all your schedule mentoring
                </span>
            </div>
        </div>

        <a-table
            class="ant-table-striped" 
            :columns="columns" 
            :data-source="schedules"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            bordered
        >
            <template #bodyCell="{ column, record }">
                <template v-if="column.dataIndex === 'action'">
                    <a-button type="link" class="text-red-500 p-0 font-semibold hover:text-red-700" @click="selectedRecord = record; cancelModal = true">
                        Cancel
                    </a-button>
                </template>
            </template>
        </a-table>
    </layout-internal-container>

    <a-modal v-model:open="cancelModal" 
        title="Confirmation" 
        centered
    >
        <p>Are you sure you want to cancel this schedule?</p>

        <template #footer>
            <a-button key="back" @click="cancelModal = false" class="hover:text-black">No</a-button>
            <a-button key="submit" type="primary" class="bg-red-500 hover:bg-red-700" :loading="loading" @click="cancelSchedule(selectedRecord?.key)">Yes</a-button>
        </template>
    </a-modal>
</template>
  
<script setup>
import { ref, onMounted } from 'vue';
import { IconSquareXFilled } from '@tabler/icons-vue';
import moment from 'moment';
import axios from "@/plugins/axios";
import { message } from 'ant-design-vue';

const schedules = ref([]);
const cancelModal = ref(false);
const loading = ref(false);
const selectedRecord = ref(null);

const columns = [
    {
        title: 'Program',
        dataIndex: 'program',
        key: 'program',
        ellipsis: true,
    },
    {
        title: 'Date & Time',
        dataIndex: 'datetime',
        key: 'datetime',
        width: 400,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        ellipsis: true,
    },
    {
        title: 'Company Name',
        dataIndex: 'companyName',
        key: 'companyName',
        width: 150,
        ellipsis: true,
    },
    {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        width: 150,
    },
];
// const data = [
//     {
//         key: '1',
//         program: 'Visa 2025',
//         datetime: moment('2024-11-20', 'YYYY-MM-DD').format('dddd, DD MMMM YYYY') + ' ' + formatTime('13:00:00') + ' - ' + formatTime('13:30:00'),
//         name: 'Ratih Permatasari',
//         companyName: 'RECTmedia',
//     },
//     {
//         key: '2',
//         program: 'Visa 2025',
//         datetime: moment('2024-11-20', 'YYYY-MM-DD').format('dddd, DD MMMM YYYY') + ' ' + formatTime('13:30:00') + ' - ' + formatTime('14:00:00'),
//         name: 'Yohan Gundala',
//         companyName: 'Decodes Media',
//     },
// ];

onMounted(() => {
    fetchSchedule();
})

const fetchSchedule = async () => {
    try {
        const response = await axios.get(`/mentor/booked-schedule`);
    
        schedules.value = response.data.data.map((item, index) => ({
            key: item.id,
            program: item.program,
            datetime: item.date + ' ' + item.time_slot,
            name: item?.startup?.name,
            companyName: item?.startup?.company_name,
        }))
    } catch (error) {
        console.error('Error fetching schedule:', error)
    }
}

const cancelSchedule = async (scheduleId) => 
{
    loading.value = true

    try {
        const formData = new FormData(); 
        formData.append("schedule_id", scheduleId);

        const response = await axios.post(`/mentor/schedule-cancel`, formData)

        message.success(response?.data?.message);

        fetchSchedule();
    } catch (error) {
        console.error('Error canceling schedule:', error?.response?.data?.message)
        message.error(error?.response?.data?.message)
    }

    setTimeout(() => {
        fetchSchedule()
        loading.value = false
        cancelModal.value = false
        selectedRecord.value = null
    }, 500);

}
</script>
  